module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0048.jpg?v=7864e47f";